var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":'askModal_' + _vm.id,"title":_vm.title,"no-close-on-backdrop":""},on:{"ok":_vm.handleOk,"close":_vm.handleClose,"cancel":_vm.handleCancel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }